/* eslint-disable */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const RichTextEditor = ({ value, onChange, placeholder = 'Enter content...', required = false }) => {
    const editorRef = useRef(null);
    const quillRef = useRef(null);
    const isUpdatingRef = useRef(false);
    const [isEmpty, setIsEmpty] = useState(true);

    const checkEmpty = useCallback(() => {
        if (!quillRef.current) return;
        const text = quillRef.current.getText().trim();
        const empty = text === '' || text === '\n';
        setIsEmpty(empty);
    }, []);

    useEffect(() => {
        if (!editorRef.current) return;

        // Initialize Quill only once
        if (!quillRef.current) {
            quillRef.current = new Quill(editorRef.current, {
                theme: 'snow',
                placeholder: placeholder,
                modules: {
                    toolbar: [
                        [{ 'header': [1, 2, 3, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'color': [] }, { 'background': [] }],
                        ['link', 'image'],
                        ['clean']
                    ],
                },
                formats: [
                    'header',
                    'bold', 'italic', 'underline', 'strike',
                    'list', 'bullet',
                    'color', 'background',
                    'link', 'image'
                ]
            });

            // Set initial content
            const initialValue = value || '';
            if (initialValue) {
                quillRef.current.root.innerHTML = initialValue;
            }
            checkEmpty();

            // Listen for text changes
            quillRef.current.on('text-change', () => {
                if (isUpdatingRef.current) return;

                const content = quillRef.current.root.innerHTML;
                const cleanContent = content === '<p><br></p>' ? '' : content;
                onChange(cleanContent);
                checkEmpty();
            });
        }
    }, [placeholder, onChange, checkEmpty]);

    // Update content when value prop changes externally
    useEffect(() => {
        if (!quillRef.current || isUpdatingRef.current) return;

        const currentContent = quillRef.current.root.innerHTML;
        const cleanCurrentContent = currentContent === '<p><br></p>' ? '' : currentContent;
        const cleanValue = value === '<p><br></p>' ? '' : (value || '');

        if (cleanCurrentContent !== cleanValue) {
            isUpdatingRef.current = true;
            quillRef.current.root.innerHTML = cleanValue || '';
            checkEmpty();
            setTimeout(() => {
                isUpdatingRef.current = false;
            }, 0);
        }
    }, [value, checkEmpty]);

    return (
        <div style={{ marginBottom: '12px' }}>
            <div
                ref={editorRef}
                style={{
                    background: '#e5eff8',
                    borderRadius: '14px',
                    border: required && isEmpty ? '2px solid #dc2626' : '1px solid #cfd8dc',
                    minHeight: '200px'
                }}
            />
            {required && isEmpty && (
                <div style={{
                    color: '#dc2626',
                    fontSize: '12px',
                    marginTop: '4px',
                    marginLeft: '4px'
                }}>
                    This field is required
                </div>
            )}
            <style>{`
                .ql-container {
                    min-height: 150px;
                    font-size: 16px;
                    color: #0c1415;
                }
                .ql-editor {
                    min-height: 150px;
                }
                .ql-editor.ql-blank::before {
                    color: #707F81;
                    font-style: normal;
                }
                .ql-toolbar {
                    background: #f0f4f8;
                    border-top-left-radius: 14px;
                    border-top-right-radius: 14px;
                    border-bottom: 1px solid #cfd8dc;
                }
                .ql-container {
                    border-bottom-left-radius: 14px;
                    border-bottom-right-radius: 14px;
                }
            `}</style>
        </div>
    );
};

export default RichTextEditor;

